{
  "ModalTitleMc": "Bellen",
  "ModalTitleTo": "Stuur oproep naar",
  "ModalTitleMcc": "Aanvraag doorsturen naar:",
  "SubTitle": "Kies bestand",
  "SelectLabel": "Telefoon Nee:",
  "SelectPlaceholder": "bijv. 01234567899",
  "SelectNoItems": "Onbekend nummer",
  "FooterHelp": "Helpen?",
  "FooterOk": "Oke",
  "FooterClose": "Dichtbij",
  "CallTargetting_Description": "Selecteer een intern bestemmingsapparaat uit de lijst of voer het bestemmingstelefoonnummer handmatig in.",
  "NAME": "CallTargetting"
}